import React from "react";
import { paragraphTitle } from "./about";
import { paragraph2 } from "./about";
import { aboutList } from "./about";
import Footer from "../../Components/Footer/Footer";
import maskgroup from "./assets/Mask Group 260@2x.png";
import group from "./assets/Group 54204.svg";
import MobileAbout from "./assets/MobileAbout.png";

import { OpenLoginSignUp } from "../../Actions/ToggleSignupA";
import { useDispatch } from "react-redux";

const AboutNewSection = () => {
    const Dispatch = useDispatch();

  return (
    <div className="w-full flex flex-col gap-[20px] mt-[80px]">
        <div className="w-full h-[550px] lg:h-[600px] 4xl:h-[700px] flex lg:justify-center lg:items-center text-[#FFFFFF] rounded-b-[60px] lg:rounded-b-none"
        style={{
            background: 'transparent linear-gradient(90deg, #372354 0%, #582E92 100%) 0% 0% no-repeat padding-box',
        }}>
            <div className="w-full lg:w-[90%] 4xl:w-[85%] mt-[20px] lg:mt-[0px] flex flex-col lg:flex-row items-center lg:justify-between">
                <div className="w-full lg:w-[50%] 2.5xl:w-[60%]">
                <h3 className="AboutPagetext font-bold text-center lg:text-left text-[28px] lg:text-[45px]">
                    About Vehicle Learning Innovation (VLI)
                </h3>

                <h4 className="Regularfont text-center lg:text-left text-[16px] lg:text-[26px] mt-[15px] lg:mt-[10px]">
                    Revolutionizing the Future of Vehicle Learning.
                </h4>
                </div>

                <div className="mt-[70px] lg:mt-[50px]">
                    <img
                        src={maskgroup}
                        alt="Vehicle Learning Illustration"
                        className="hidden lg:block w-[600px] 4xl:w-[800px] h-full"
                    />

                     {/* Mobile Image */}
                     <img
                        src={MobileAbout}
                        alt="Vehicle Learning Illustration Mobile"
                        className="block lg:hidden w-full h-auto"
                    />
                </div> 

               
            </div>
        </div>


        <div className="w-full flex items-center justify-center">
            <div className="w-[90%] lg:w-[80%] flex flex-col gap-[20px] lg:gap-[30px] Regularfont">
                    <p className="mt-[20px] lg:mt-[40px] text-[16px] lg:text-[24px] leading-[35px] lg:leading-[38px]">{paragraphTitle}</p>
                    <div className="text-[16px] lg:text-[24px] leading-[35px] lg:leading-[38px]">
                        <p>{paragraph2}</p>
                    </div>

                    <ul>
                    {aboutList.map((a) => (
                        <li className="mb-[30px] list-none " key={a.key}>
                            <h3 className="text-[18px] lg:text-[38px] font-semibold italic">{a.title}</h3>
                            <p className="text-[16px] lg:text-[24px] mt-[10px] leading-[35px] lg:leading-[38px]">{a.description}</p>
                            <p className="text-[16px] lg:text-[24px] mt-[30px] lg:mt-[50px] leading-[35px] lg:leading-[38px]">{a.description2}</p>
                        </li>
                    ))}
                    </ul>

                    <div className="w-full flex flex-col lg:flex-row lg:justify-between">
                        <div className="w-full lg:w-[50%] flex flex-col gap-[20px]">
                            <h3 className="text-[18px] lg:text-[38px] font-semibold italic">Why VLI?</h3>
                            <p className="text-[16px] lg:text-[24px] leading-[35px] lg:leading-[38px]">
                            Vehicle Learning Innovation (VLI) helps your institute grow smarter, scale faster, and lead in the vehicle training education space with next generation tools powered by AI and unmatched visibility.
                            </p>
                            {/* <p className="text-[17px] lg:text-[25px] font-semibold italic w-[500px]">
                            (For Vehicle Training Institutes & Instructors (Our Partners))
                            </p> */}

                            <div className="w-full hidden lg:flex gap-[20px] mt-[15px]">
                                    <button
                                        className="w-[200px] lg:w-[200px] h-[55px] rounded-[11px] bg-[#A1A3EF] text-[#FFFFFF] text-[22px] shadow-[4px_8px_6px_#00000029]"
                                        onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
                                    >
                                        Sign up as learner
                                    </button>
                                    <button
                                        className="w-[200px] lg:w-[200px] h-[55px] rounded-[11px] bg-[#A1A3EF] text-[#FFFFFF] text-[22px] shadow-[4px_8px_6px_#00000029]"
                                        onClick={() =>
                                        Dispatch(OpenLoginSignUp("Register", true, "Partner"))
                                        }
                                    >
                                        Sign up as partner
                                    </button>
                            </div>

                            {/* <div className="flex gap-4">
                                <button
                                    className="rounded-[11px] bg-[#A1A3EF] py-2 px-4 text-white opacity-100 shadow-[4px_8px_6px_#00000029] transition-opacity hover:bg-[#9193d5]"
                                    onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
                                >
                                    sign up as learner
                                </button>
                                <button
                                    className="rounded-[11px] bg-[#A1A3EF] py-2 px-4  text-white opacity-100 shadow-[4px_8px_6px_#00000029] transition-opacity hover:bg-[#9193d5]"
                                    onClick={() =>
                                    Dispatch(OpenLoginSignUp("Register", true, "Partner"))
                                    }
                                >
                                    sign up as partner
                                </button>
                            </div> */}
                        </div>

                        <div className="w-full lg:w-[50%] mt-[30px] lg:mt-[70px]">
                            <img src={group} alt="group" className="h-auto w-full" />
                        </div>

                        <div className="w-full lg:hidden flex gap-[20px] mt-[15px]">
                                    <button
                                        className="w-[200px] lg:w-[200px] h-[55px] rounded-[11px] bg-[#A1A3EF] text-[#FFFFFF] text-[18px] lg:text-[22px] shadow-[4px_8px_6px_#00000029]"
                                        onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
                                    >
                                        Sign up as learner
                                    </button>
                                    <button
                                        className="w-[200px] lg:w-[200px] h-[55px] rounded-[11px] bg-[#A1A3EF] text-[#FFFFFF] text-[18px] lg:text-[22px] shadow-[4px_8px_6px_#00000029]"
                                        onClick={() =>
                                        Dispatch(OpenLoginSignUp("Register", true, "Partner"))
                                        }
                                    >
                                        Sign up as partner
                                    </button>
                            </div>
                    </div>
            </div>
        </div>

        <Footer /> 
    </div>
  );
};

export default AboutNewSection ;

